import React from 'react';
import { Route, Switch, withRouter } from 'react-router';
import CachedResponse from '../common/CachedResponse';
import NotFound from '../NotFound';
import InstallerDetails from './InstallerDetails';
import SearchInstaller from './SearchInstaller';
import { ROLE_INSTALLER } from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';

const Installer = () => {
  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/setup/search">
          <CachedResponse
            listEndpoint={'app-choices'}
            render={appChoices => <SearchInstaller appChoices={appChoices} />}
          />
        </Route>
        <Route exact path="/setup/:id">
          <InstallerDetails />
        </Route>

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  if (!userHasAnyRole(ROLE_INSTALLER)) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  return getActivePage();
};

export default withRouter(Installer);
